import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import DateSince from '../../../components/Date';
import createLink from "../../../../libs/createLink";


class ProfileForumList extends React.Component {

    componentWillMount() {
        this.props.getArticlesDating({userId: this.props.userId, count: true}, "datingPop");
    }

    render() {
        return (
            <div className="card container profil-forum-list">
                <table class="table">
                    <thead>
                    <tr>
                        <th>Titre</th>
                        <th>Forum</th>
                        <th>Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.articles.map((item) => {
                        let departement = item.breadcrumb.slice(3, 4)[0];
                        return (
                            <tr>
                                <td className="title"><Link to={createLink("forumTopic", {category : {slug : item.forum.slug, _id : item.forum._id}, topic : {_id : item._id, slug : item.slug}}) }>{item.title}</Link>
                                </td>
                                <td className="link"><Link to={departement.link}>{departement.name}</Link></td>
                                <td className="date"><DateSince
                                    date={item.createdAt}
                                    prefix={true}
                                    currentFormat={true}
                                /></td>
                            </tr>
                        )
                    })}

                    </tbody>
                </table>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileForumList);
